import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
`

export const InfoContainer = styled.div`
  display: flex;
  background-color: ${theme.colors.alert.info.ligther};
  gap: ${theme.spacing.xm};
  padding: 12px 16px;
  border-radius: ${theme.shapes.borderRadius.sm};
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const InfoTitle = styled.span`
  color: ${theme.colors.primary.main};
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.xl};
`

export const InfoValue = styled.span`
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.xm};
`
